
export default function () {

  return {
    // item: null,
    // tempItem: null,
    // items: [],
    // skip: 0,
    limit: 24,
    // total: 0,
    orderBy: 'createdAt',
    orderDesc: true,
    searchBy: ['fiscalDocumentNumber'],
    // searchQuery: '',
    // where: {},
    // loading: false,
    // include: ['city'],
    // fields: [],
  };
}
